import { api } from '../lib/api';

/**
 * What a person wants to hear about their recordings, and how. Four events,
 * two channels each; the page sends back only what it changed.
 */

export const NOTIFICATION_EVENTS = ['first_view', 'new_viewer', 'reaction', 'comment'] as const;
export type NotificationEvent = (typeof NOTIFICATION_EVENTS)[number];

export const NOTIFICATION_CHANNELS = ['email', 'push'] as const;
export type NotificationChannel = (typeof NOTIFICATION_CHANNELS)[number];

export type NotificationSettings = Record<NotificationEvent, Record<NotificationChannel, boolean>>;

export interface NotificationPrefs {
  settings: NotificationSettings;
  /** Phones signed in with the Slate app, where push notifications land. */
  pushDevices: number;
}

export type NotificationPatch = Partial<Record<NotificationEvent, Partial<Record<NotificationChannel, boolean>>>>;

export function fetchNotificationPrefs(): Promise<NotificationPrefs> {
  return api<NotificationPrefs>('/v1/me/notifications');
}

export function updateNotificationPrefs(patch: NotificationPatch): Promise<NotificationPrefs> {
  return api<NotificationPrefs>('/v1/me/notifications', { method: 'PUT', body: patch });
}
